import React from 'react';
import { Grid } from '@material-ui/core';

import { ClientCutoutModalTabs } from '../../enums/ClientCutoutModalTabs';
import { TableEmpty } from '../../../../shared/components/TableEmpty';
import { CutoutModalOrganogram } from './CutoutOrganogram/CutoutModalOrganogram';
import { CutoutKeywords } from './CutoutKeywords/CutoutKeywords';
import { CutoutModel } from '../../../../Models/CutoutModel';
import { CutoutVehicles } from './CutoutVehicle/CutoutVehicle';
import { ClientContext } from '../../ClientContext';

interface ICutoutModalPagesProps {
    currentTab: ClientCutoutModalTabs,
    editMode: boolean,
    currentCutout: CutoutModel
    setCurrentCutout: (cutout: CutoutModel) => void,
}

export function CutoutModalPages({ currentTab, editMode, currentCutout, setCurrentCutout }: ICutoutModalPagesProps) { 
    const clientContext = React.useContext(ClientContext);

    const getKeywordsPage = () => {
        if (clientContext.keywords.length > 0) {
            return (
                <Grid item xs={12}>
                    <CutoutKeywords
                        cutout={ currentCutout }
                        setCutout={ setCurrentCutout } />
                </Grid>
            );
        }
        else {
            return (
                <Grid item xs={12}>
                    <TableEmpty 
                        displayText="É necessário o cadastro de palavras-chave para a associação com recortes."
                        cssProperties={{ 
                            minHeight: '150px',
                        }} /> 
                </Grid>
            );
        }
    };


    const getVehiclesPage = () => {
        if (clientContext.vehicles.length > 0) {
            return (
                <Grid item xs={12}>
                    <CutoutVehicles
                        cutout={ currentCutout }
                        setCutout={ setCurrentCutout }/>
                </Grid>
            );
        }
        else {
            return (
                <Grid item xs={12}>
                    <TableEmpty 
                        displayText="É necessário associar veículos ao cliente para realizar a associação com recortes."
                        cssProperties={{ 
                            minHeight: '150px',
                        }} /> 
                </Grid>
            );
        }
    };

    return (
        <> 
            {currentTab === ClientCutoutModalTabs.ORGANOGRAM && (
                <Grid item xs={12}>
                    <CutoutModalOrganogram />
                </Grid>
            )}
            {currentTab === ClientCutoutModalTabs.TAGS && getKeywordsPage()}
            {currentTab === ClientCutoutModalTabs.VEHICLE && getVehiclesPage()}
            {currentTab === ClientCutoutModalTabs.DEFAULT && (
                <TableEmpty 
                    displayText={`Selecione uma das abas para iniciar ${editMode ? 'a edição': 'o cadastro'} do recorte.`}
                    cssProperties={{ 
                        minHeight: '150px',
                    }} /> 
            )}
        </>
    );
}